function partition(arr, ...checkFns) {
  const rest = [];
  const result = new Array(checkFns.length).fill(1).map(() => []);

  for (let i = 0; i < arr.length; i++) {
    let added = false;
    const item = arr[i];
    for (let x = 0; x < checkFns.length; x++) {
      const testFn = checkFns[x];
      if (!added && testFn(item)) {
        result[x].push(item);
        added = true;
      }
    }
    if (!added) {
      rest.push(item);
    }
  }

  return [rest, ...result];
}

export default partition;
